import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FileStatusButton, FileStatusPanelItem, FileStatusSubtitle, FileStatusThumbnail, FileStatusTitle } from "@air/feature-file-status/ui";
import { getSubtitleWithProgress } from "@air/feature-file-status/utils";
import { Close, Play, Skip } from "@air/next-icons";
import classNames from "classnames";
import { memo } from "react";
import isEqual from "react-fast-compare";
import { SHARED_PANEL_ITEM_CLASS_NAMES } from "../../constants";
export const FileStatusTrackingPanelListItemPaused = /*#__PURE__*/ memo((param)=>{
    let { onSkip, onCancel, onResume, item, item: { title, onRowClick, previewLoader, avatar, thumbnailSource, subtitle, sizeInBytes, ext, currentBytesUploaded, status } } = param;
    return /*#__PURE__*/ _jsx(FileStatusPanelItem, {
        onClick: onRowClick,
        previewLoader: previewLoader,
        className: classNames("hover:bg-grey-3", SHARED_PANEL_ITEM_CLASS_NAMES, !!onRowClick && "cursor-pointer"),
        avatar: avatar !== null && avatar !== void 0 ? avatar : /*#__PURE__*/ _jsx(FileStatusThumbnail, {
            ext: ext,
            status: status,
            thumbnailSource: thumbnailSource
        }),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: title
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            children: subtitle !== null && subtitle !== void 0 ? subtitle : getSubtitleWithProgress({
                title: "Paused",
                uploadedBytes: currentBytesUploaded,
                sizeInBytes
            })
        }),
        buttons: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                onResume && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: ()=>onResume(item),
                    label: "Resume",
                    children: /*#__PURE__*/ _jsx(Play, {
                        className: "size-4"
                    })
                }),
                onSkip && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: ()=>onSkip(item),
                    label: "Skip",
                    children: /*#__PURE__*/ _jsx(Skip, {
                        className: "size-4"
                    })
                }),
                onCancel && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: ()=>onCancel(item),
                    label: "Cancel",
                    children: /*#__PURE__*/ _jsx(Close, {
                        className: "size-4"
                    })
                })
            ]
        })
    });
}, isEqual);
FileStatusTrackingPanelListItemPaused.displayName = "FileStatusTrackingPanelListItemPaused";
